import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getUnclaimedConfirmation } from '@/api/home';
import { json2excel } from '@/util/json2excel';
import validate from '@zzzj/zzzj/src/validate';
import { mapState } from 'vuex';
export default {
  name: 'unclaimed',
  computed: _objectSpread({
    searchQuery: function searchQuery() {
      var key = [];
      if (this.model.c01TaskCode) {
        key.push("c01TaskCode == \"".concat(this.model.c01TaskCode, "\""));
      }
      if (this.model.c01CusName) {
        key.push("c01CusName.contains(\"".concat(this.model.c01CusName, "\")"));
      }
      if (this.model.c01StrucCode) {
        key.push("c01StrucCode == \"".concat(this.model.c01StrucCode, "\""));
      }
      if (this.model.c01StrucCode) {
        key.push("c01StrucCode == \"".concat(this.model.c01StrucCode, "\""));
      }
      if (this.model.fic) {
        key.push("fic == \"".concat(this.model.fic, "\""));
      }
      if (this.model.unclaimedCount) {
        key.push("unclaimedCount ".concat(this.model.type, " ").concat(this.model.unclaimedCount));
      }
      return key.join(' and ');
    }
  }, mapState('cpscc', ['strucList'])),
  data: function data() {
    var validateUnclaimedCount = function validateUnclaimedCount(rule, value, callback) {
      if (value !== undefined && value !== '') {
        if (validate.isNum(value)) {
          return callback();
        } else {
          return callback(new Error('请输入正确的数字'));
        }
      }
      return callback();
    };
    return {
      loading: false,
      tableData: [],
      model: {
        c01TaskCode: undefined,
        c01CusName: undefined,
        c01StrucCode: undefined,
        fic: undefined,
        unclaimedCount: undefined,
        type: '>'
      },
      rules: {
        unclaimedCount: [{
          validator: validateUnclaimedCount,
          message: '请输入正确的数字',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.tableData = [];
              _context.n = 1;
              return _this.$awaitTo(getUnclaimedConfirmation({
                searchQuery: _this.searchQuery,
                pagesize: 9999
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this.tableData = data.map(function (item) {
                  var res = _this.strucList.find(function (sub) {
                    return sub.l01StrucCode === item.c01StrucCode;
                  });
                  return _objectSpread(_objectSpread({}, item), {}, {
                    _structCode: res ? "(".concat(res.l01StrucCode, ")").concat(res.l01Name) : item.c01StrucCode
                  });
                });
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index !== 4) {
          sums[index] = 'N/A';
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 份';
        }
      });
      return sums;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$checkForm();
            case 1:
              _this2.getList();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    export2Excel: function export2Excel() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var name, excelHeader, data, line, i, sum, footer, excelData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              name = '未领取.xlsx';
              excelHeader = [['作业编码', '客户名', '架构', '现场负责人', '未领取数']];
              data = _this3.tableData.map(function (item) {
                return [item.c01TaskCode, item.c01CusName, item._structCode, item.fic, item.unclaimedCount];
              });
              line = [];
              for (i = 0; i < excelHeader[0].length - 2; i++) {
                line.push('');
              }
              sum = _this3.tableData.reduce(function (a, b) {
                return a + b.unclaimedCount;
              }, 0);
              footer = [['合计'].concat(line, [sum])];
              excelData = [].concat(excelHeader, _toConsumableArray(data), footer);
              json2excel(excelData, name);
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};